import { ErrorMessage } from "@hookform/error-message";
import { Typography, TypographyProps } from "@mui/material";
import type { FieldErrors } from "react-hook-form";

interface HelperMessageProps {
  errors?: FieldErrors;
  showError?: boolean;
  name: string;
  message?: string;
  messageProps?: React.HTMLAttributes<HTMLParagraphElement>;
  textVariant?: TypographyProps["variant"];
}

export const HelperMessage = ({
  errors,
  name,
  showError = true,
  message,
  messageProps = {},
  textVariant = "labelS",
}: HelperMessageProps) => {
  if (!name) {
    return null;
  }

  if (errors && showError) {
    return (
      <div className="mt-1 h-4 leading-4">
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message: errorMessage }) => (
            <Typography color="error" variant={textVariant}>
              {errorMessage}
            </Typography>
          )}
        />
      </div>
    );
  }

  if (message) {
    return (
      <p className="body-m" {...messageProps}>
        {message}
      </p>
    );
  }

  return null;
};
